export const AUTH_TYPES = Object.freeze({
  BCID: 'bcid',
  OKTA: 'okta',
  PING: 'ping',
  DUO: 'duo',
  SMS: 'sms',
  HID: 'hid',
  NONE: 'none',
})

const AuthenticatorMixin = {
  data() {
    return {
      AUTH_TYPES,
    }
  },
  methods: {
    isDefaultAuthenticator(defaultAuthenticator, authenticatorType) {
      if (defaultAuthenticator && defaultAuthenticator.authenticator) {
        return defaultAuthenticator.authenticator === authenticatorType
      }
    },
    generateSettingsPayload(isDefaultChecked, authenticator, uuid) {
      let _accountSettingPayload = {
        authenticator: this.AUTH_TYPES.NONE,
        credentialUUID: null,
      }
      if (isDefaultChecked) {
        _accountSettingPayload = {
          authenticator: authenticator,
          credentialUUID: uuid,
        }
      }
      return _accountSettingPayload
    },
  },
}

export default AuthenticatorMixin
